import { useCallback } from 'react'
import { useDispatch, useSelector } from 'react-redux'

import { apolloService } from '../../common/services'

import { BRANDS_WITH_NO_TOP_200_MENU_QUERY } from '../graphql/queries'
import { FETCH_BRANDS_WITH_NO_TOP_200_MENU } from '../redux/action-types'

const useBrandsWithNoTop200MenuLazyQuery = () => {
  const dispatch = useDispatch()

  const data = useSelector(
    store => store.priorityTasks.priorityTask.brandsWithNoTop200Menu,
  )

  const fetch = useCallback(
    () =>
      apolloService.query({
        query: BRANDS_WITH_NO_TOP_200_MENU_QUERY,
        dispatch,
        action: FETCH_BRANDS_WITH_NO_TOP_200_MENU,
      }),
    [dispatch],
  )

  return [fetch, { data }]
}

export default useBrandsWithNoTop200MenuLazyQuery
